import script from "./DivisionesMaquinariaAgricolaPrivadoView.vue?vue&type=script&setup=true&lang=js"
export * from "./DivisionesMaquinariaAgricolaPrivadoView.vue?vue&type=script&setup=true&lang=js"

import "./DivisionesMaquinariaAgricolaPrivadoView.vue?vue&type=style&index=0&id=5a89d881&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a89d881"]])

export default __exports__